<template>
    <div>
        <div :style="{ display: descargaVisible ? 'block' : 'none' }">
            <div class="DescargarActaCalificacionesDocenteSabana" style="width: 1754px; height: 1240px; color: black;">
                <div class="content">
                    <h1 class="mb-2">Acta de calificaciones <i><small>({{parametros.periodo}})</small></i></h1>
                
                    <div class="my-2" style="border: 1px solid #D9D9D9; padding: 5px 9px; margin-bottom: 5px;">
                        <vs-row>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" v-if="users.params_calificacion"><strong> {{users.params_calificacion.docente}}</strong></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" style="padding: 0 9px;"><strong>{{parametros.codigo}} </strong></p>
                            </vs-col>
                            <vs-col w="4">
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" style="padding-right: 18px;">   {{parametros.institucion}}
                                </p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether">{{parametros.cicloEscolar}}</p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether">GRUPO ACADÉMICO: <span class="text-uppercase">{{parametros.grupoS}}</span></p>
                            </vs-col>
                            <vs-col w="4" v-if="users.clases_impartidas">
                                <p class="fontEight lineTogether">NO. DE CLASES IMPARTIDAS: <span class="text-uppercase">{{users.clases_impartidas}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" style="padding-right: 18px;">FECHA DE ACTA GENERADA: <span>{{hoy}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether">CAPTURADO: <span class="text-uppercase">{{fechaModificacion}}</span></p>
                            </vs-col>
                        </vs-row>
                    </div>
                    
                    <div class="d-flex padding9">
                        <div style="width: 10%" class="fontEight px-1 cabeceraTable">
                            <p style="hyphens: auto;">No. lista </p>
                        </div>
                        <div style="width: 30%" class="fontEight px-1 cabeceraTable">
                            <p style="hyphens: auto;">Nombre </p>
                        </div>
                        <div style="width: 10%" class="fontEight px-1 cabeceraTable">
                            <p style="hyphens: auto;">Grupo admin.</p>
                        </div>
                        <div class="d-flex text-center" style="width: 50%">
                            <div v-for="(materia, i) in materias" :key="i" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">{{materia.asignatura}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="backgroundCampos p-1" v-for="(alumno, a) in users.alumnos" :key="a">
                        <div class="d-flex">
                            <div style="width: 10%" class="fontSix px-1 cabeceraTableCenter ">
                                <p style="hyphens: auto;">{{alumno.no_lista}} </p>
                            </div>
                            <div style="width: 30%" class="fontSix px-1 cabeceraTable">
                                <p style="hyphens: auto;">{{alumno.alumno_name}} - <i>{{alumno.alumno_matricula}}</i></p>
                            </div>
                            <div style="width: 10%" class="fontSix px-1 cabeceraTableCenter ">
                                <p style="hyphens: auto;">{{alumno.grupo_administrativo}}</p>
                            </div>
                            <div v-if="alumno.sabana_alumno.length" class="d-flex" style="width: 50%">
                                <div  v-for="(calif, c) in alumno.sabana_alumno" :key="c" class="fontEight px-1 cabeceraTableCenter" :class="'widthCabecera' + numCabecera">
                                    <p style="hyphens: auto;">{{calif.calificacion}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
export default {
    props: ['parametros', 'users', 'fechaModificacion', 'hoy', 'materias'],
    data(){
        return{
            numCabecera: '',
            loadingDescarga: null,
            descargaVisible: false
        }
    },
    methods: {
        getNumTotalCabecera(){
            console.log('materias', this.materias)   
            const vm = this
            vm.numCabecera = vm.materias.length
            console.log('materias', vm.numCabecera) 
        },
    
        loadingProgreso(){
        this.loadingDescarga = this.$vs.loading({
            text: 'No cierre la ventana. Generando PDF'
        });
        },
        async getGenerarPDFActas() {
            this.getNumTotalCabecera()
            this.loadingProgreso(0)
        try {
            this.descargaVisible = true;
            setTimeout(()=>{
                this.generateAndDownloadPDF()
            }, 1500)
        } catch (error) {
            console.log(error)
        }
        },
        async generateAndDownloadPDF() {
            
            console.log('entro a descargar');
        // Crea un nuevo objeto jsPDF
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'letter',
                compress: true,
                setMargins: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            });
            // Nombre del archivo PDF
            const pdfFileName = this.users.params_calificacion.docente + '.pdf';
            // Itera sobre los elementos y agrega cada página al PDF
        
            const elementToCapture  = document.querySelectorAll('.DescargarActaCalificacionesDocenteSabana');
            // Usa html2canvas para capturar el contenido como una imagen
            const canvas = await html2canvas(elementToCapture[0], {
                scale: 1,
                useCORS: true, // Agrega esta línea para solucionar problemas con CORS
            });
            console.log("abajo de await")
            // Convierte la imagen del canvas a datos URL
            const imageData = canvas.toDataURL('image/jpeg');
            console.log("despues de imageData")
            // Agrega la imagen al PDF
            pdf.addImage(imageData, "JPEG", 3, 5, 270, 200, '', 'FAST');
            console.log("abajo de addImage")
            // Guarda o abre el PDF
            pdf.save(pdfFileName);
            
            setTimeout(()=>{
                console.log('Descarga completada');
                this.descargaVisible = false;
                this.loadingDescarga.close();
            }, 1000);
        },
    },
    watch:{
        users(){
            console.log("entro aqui")
            this.getNumTotalCabecera()
        }
    }
}
</script>
<style scoped>
.objetfit > img{
	width: 1240px;
	height: 150px;
	object-fit: cover;
}
.fontTen{
    font-size: 12px;
}
.fontSix{
    font-size: 13px;
}
.fontEight{
    font-size: 15px;
}
.fontNine{
    font-size: 16px;
}
.cabeceraTable{
    font-weight: 500;
    line-height: 1.5;
}
.cabeceraTableCenter{
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
}
p{
    margin-bottom: 0;
}
.lineTogether {
    line-height: 1.5;
}
table tr th{
    font-size: 7px;
    margin: 0 2px;
}
.widthCabecera1{
    width: 100%;
}
.widthCabecera2{
    width: 50%;
}
.widthCabecera3{
    width: 33.3%;
}
.widthCabecera4{
    width: 25%;
}
.widthCabecera5{
    width: 20%;
}
.widthCabecera6{
    width: 16.6%;
}
.widthCabecera7{
    width: 14.28%;
}
.widthCabecera8{
    width: 12.5%;
}
.widthCabecera9{
    width: 11.11%;
}
.widthCabecera10{
    width: 10%;
}
.widthCabecera11{
    width: 9%;
}
.widthCabecera12{
    width: 8.33%;
}
.widthCabecera13{
    width: 7.69%;
}
.widthCabecera14{
    width: 7.14%;
}
.widthCabecera15{
    width: 6.66%;
}
.widthCabecera16{
    width: 6.25%;
}
.lineSeparadorCampoFormativo{
    width: 100%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0;
}
.lineSeparador{
    width: 99.5%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0 2px 0.5%;
}
.backgroundCampos:nth-last-child(even){
    background: rgba(217, 217, 217, 0.6);
}
.bottom-div {
    position: absolute;
    bottom: 35px;
    width: 1240px;
    text-align: center;
}
.padding9{
    padding: 0 9px;
}
.fs-18{
    font-size: 18px;
}
.fw-bold{
    font-weight: bold;
}
</style>